import { Link } from 'react-router-dom';
import { categories, popularTags } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading text-primary-400 whitespace-nowrap" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              韩漫大全
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              韩漫大全免费平台是韩国漫画在线阅读网标杆，每日更新最新章节，提供海量韩漫资源，支持评论与收藏功能，让您随时随地畅享韩漫阅读乐趣。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-heading text-foreground-50 mb-5">漫画分类</h3>
            <ul className="space-y-3">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    <i className={`${cat.icon} mr-2 text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-heading text-foreground-50 mb-5">热门标签</h3>
            <div className="flex flex-wrap gap-2">
              {popularTags.map((tag) => (
                <span
                  key={tag.id}
                  className="px-3 py-1 rounded-full text-xs bg-background-800 text-foreground-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {tag.name}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-base font-heading text-foreground-50 mb-5">关于我们</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  版权声明
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 韩漫大全 hanmandq.com 版权所有 | 本站内容仅供学习和交流
          </p>
          <p className="text-xs text-foreground-400">
            韩漫大全 - 韩国漫画在线阅读网标杆平台
          </p>
        </div>
      </div>
    </footer>
  );
}